import YoungPersonScreen from './YoungPersonScreenContainer';
export default YoungPersonScreen;
